// extracted by mini-css-extract-plugin
export default {"wrapper":"Pz-z","viewport":"Qz-z","container":"Rz-z","slide":"Sz-z"};